<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">sub-table-temp-device-embedded-detail</div>
    <div :class="'container ' + pageContainerSize">
      <ag-grid-vue style="width: 100%; height: 530px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
        <br>
             件数<input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_device_embedded_detail";
import { utils } from "@/libs/utils";

import _debug from "debug";
var mdebug = _debug("esma:master_user");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      api_name: "temp_device_embedded_detail",
      page_acl: acl.generic
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend( fields.ref_id, {}),
        utils.extend( fields.jurisdiction_classification, {}),
        utils.extend( fields.department_in_charge, {}),
        utils.extend( fields.responsible_team, {}),
        utils.extend( fields.jurisdiction_system, {}),
        utils.extend( fields.jurisdiction_system_name_in_use, {}),
        utils.extend( fields.maker, {}),
        utils.extend( fields.software, {}),
        utils.extend( fields.software_jurisdiction, {}),
        utils.extend( fields.item_number, {}),
        utils.extend( fields.virtual_id, {}),
        utils.extend( fields.certificate_management_number, {})
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });


      return arr;
    },

    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {},
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// sub-table-temp-device-embedded-detail.vue?8458a214